import { useEffect } from 'react'

export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: (event: TouchEvent | MouseEvent) => void
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current) return

      // Use composedPath() to correctly detect clicks inside Shadow DOM,
      // where event.target is retargeted to the shadow host at document level.
      const path = event.composedPath()
      if (path.includes(ref.current)) return

      handler(event)
    }

    document.addEventListener('mousedown', listener, { passive: true })
    document.addEventListener('touchstart', listener, { passive: true })
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
